import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaA_Van_Right: React.FC<AreaSVGProps> = ({
  fill = '#EE2A2A',
  stroke = '#EE2A2A',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="103"
      height="115"
      viewBox="0 0 103 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_van_right"
          x="0"
          y="0"
          width="103"
          height="115"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_a_van_right)">
        <path
          d="M43.2148 2.52734C40.8104 5.02014 38.6824 7.17331 37.9795 7.84375V7.84473L37.9697 7.85449L37.96 7.86328C37.5543 8.24855 36.4828 9.35087 35.665 9.97168C35.1871 10.3345 34.2853 10.9555 33.0576 11.2471C31.6074 11.5913 30.0188 11.3964 28.6172 10.5293L28.5986 10.5205L28.5557 10.4932C27.781 10.0011 27.0018 9.22161 26.585 8.79785C26.0203 8.22377 25.3872 7.53198 24.7881 6.82812C24.7024 6.72741 24.6176 6.62353 24.5312 6.51953L24.4443 6.85352L24.4424 6.85938C22.4495 14.8032 19.0412 32.5969 17.0059 43.583L16.9805 43.7217L16.9785 43.7266C15.9576 49.1993 14.9975 53.1231 13.7617 56.3135C12.4775 59.6286 10.9574 61.9921 9.05762 64.4219L9.05469 64.4277L8.99219 64.5078C7.14799 66.8543 5.19976 69.0066 3.58008 70.7832C2.51458 71.9519 1.65913 72.8907 1 73.6562V79.0684L12.8145 88.9062L13.2158 89.2402L13.1709 89.7607L11.0977 113.728C24.7227 111.203 54.0778 107.928 101.704 112.747L101.66 111.89C94.2987 111.016 88.9783 109.898 84.3633 108.337C78.9047 106.49 74.6411 104.086 69.5234 101.22H69.5215L69.3877 101.145L69.3838 101.143C57.6351 94.5427 51.4617 83.1757 50.0488 80.7617L49.6592 80.0957L49.6719 80.083C48.3081 77.554 46.7313 73.615 45.8047 71.0439L45.7783 71.0703L45.2734 69.5195C44.7441 67.8933 44.2146 64.7682 43.8262 61.791C43.4214 58.6881 43.0879 55.0969 43.0879 52.3369L43.0566 50.3418C43.0179 47.9674 43.0262 44.509 43.7119 40.4443C44.5333 35.5758 46.3033 29.8208 49.958 23.2969C48.9929 21.6379 47.956 19.8094 47.0146 18.0361C45.7417 15.6381 44.3479 12.8214 43.7461 10.6611L43.6367 10.2383C43.3105 8.86613 43.2394 6.8359 43.2158 5.125C43.2046 4.30847 43.2061 3.43227 43.2148 2.52734Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
